<template>
  <div class="content">
    <div class="detailContent">
      <div class="back" @click="$router.push('/market')" style="cursor: pointer;font-size:1.6rem"><v-icon>mdi-chevron-left</v-icon>返回</div>
      <div v-if="activityDetailDataList&&activityDetailDataList.contents&&activityDetailDataList.contents.length>0">
        <div class="detail" v-for="(item,index) in activityDetailDataList.contents" :key="index">
          <div v-if="item.contentType == 'rich_text' && item.contentCode == `ac_${$route.query.id}`">
            <h2>{{ lang=='zh'?item.contentNameZhCn:(item.contentNameEnUs?item.contentNameEnUs:item.contentNameZhCn) }}</h2>
            <p>{{ item.contentDate | dateHandle}}</p>
            <span></span>
            <div class="pb_10 richBox"  id="richText" v-html="lang=='zh'?item.contentZhCn:(item.contentEnUs?item.contentEnUs:item.contentZhCn)"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="background:#f5f5f5;margin-top:20px">
      <div class="about">相关活动</div>
      <div class="newsList">
        <div class="newsItem" v-for="(item,index) in newsList" :key="index">
            <img :src="lang=='zh'?item.picturesZhCn:(item.picturesEnUs?item.picturesEnUs:item.picturesZhCn)">
            <div class="newDetail">
                <span>{{ lang=='zh'?item.contentNameZhCn:(item.contentNameEnUs?item.contentNameEnUs:item.contentNameZhCn) }}</span>
                <p v-html="lang=='zh'?item.contentZhCn:(item.contentEnUs?item.contentEnUs:item.contentZhCn)" class="richBox"></p>
                <!-- <div style="cursor: pointer;" @click="viewDetail(item.contentId)">查看更多<v-icon color="red" >mdi-chevron-right</v-icon></div> -->
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import marketApi from '../../api/market'
  export default {
    name: 'marketDetail',
    data: () => ({
      newsList: [],
      activityDetailDataList: []
    }),
    watch:{
      '$route.query.id'(val){
        this.getData();
      },
    },
    computed:{
        //获取当前语言
        lang() {
            return this.$i18n.locale;
        },
    },
    filters:{
      dateHandle: (val)=>{
        let date = val.substring(0,val.lastIndexOf('-')+3);
        return date.replace(/-/g,'.')
      }
    },
    methods:{
        viewDetail(id){
          console.log(id,'id');
          this.$router.push( {path: '/marketDetail', query: { id: id }} );
        },
        async getData(){
          let { data: activityDetailData } = await marketApi.getActivityDetail();
          this.activityDetailDataList = activityDetailData[0];
          let { data: activityData } = await marketApi.getActivityList();
          let id = this.$route.query.id || '';
          let listItem = activityData[0].contents;
          this.newsList = [];
          for (let index = 0; index < listItem.length; index++) {
            if( id == listItem[index].contentId ){
              if( index == 0 ){
                if( listItem[index+1] ){
                  this.newsList.push( listItem[listItem.length-1], listItem[index+1] )
                }else{
                  this.newsList.push( listItem[listItem.length-1] )
                }
              }else{
                if( listItem[index+1] ){
                  this.newsList.push( listItem[index-1], listItem[index+1] )
                }else{
                  this.newsList.push( listItem[index-1], listItem[0] )
                }
              }
              break;
            }
          }
        }
    },
    mounted(){
      this.getData();
    }
  }
</script>
<style lang="scss" scoped>
  .pb_10{
    padding-bottom: 10px;
  }
  .detailContent{
    position: relative;
    width: 70%;
    min-height: 20px;
    margin-left: 15%;
    text-align: center;
    .back{
      position: absolute;
      left: 0;
      font-size: 16px;
      .v-icon{
          font-size: 24px;
          margin-top: -2px;
          transform: rotateX(45deg);
      }
    }
    .detail{
      span{
        display: block;
        height: 1px;
        width: 100%;
        background: #d6d6d6;
        margin-bottom: 10px;
      }
    }
    
  }
  .richBox{
    word-wrap:break-word;
  }
  .about{
    height: 60px;
    width: 70%;
    margin-left: 15%;
    padding: 10px;
  }
  .newsList{
        width: 70%;
        margin-left: 15%;
        padding-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        overflow: hidden;
        .newsItem{
            width: 400px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            img{
                width:100%;
                height: 200px;
            }
            .newDetail{
                display: flex;
                flex-direction: column;
                border: 1px solid #e8e8e8;
                padding: 10px;
                span{
                    font-weight: 600;
                }
                p{
                    margin: 5px 0 5px 0;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                div{
                    color: red;
                    margin-top: 10px;
                    font-size: 16px;
                    .v-icon{
                        font-size: 24px;
                        margin-top: -2px;
                        transform: rotateX(45deg);
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
  #richText{
    width: 100%;
    img{
      width: 100%!important;
    }
  }
</style>
